import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
// Components
import AboutCourse from '../components/AboutCourse';
import CourseContent from '../components/CourseContent';
// CSS
import '../assets/css/course.css'

export default function Course() {
  const [courseEnrolled, setCourseEnrolled] = useState(false);
  const { courseId } = useParams();

  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  return (
    <>
    {
      courseEnrolled ? <CourseContent /> : <AboutCourse courseId={courseId} />
    }
    </>
  )
}
